<template>
  <div class="hideTotal">
    <!-- 搜索 -->
    <table-search
      label-width="65px"
      @search="fetchList(1)"
      @reset="handleReset"
    >
      <template v-slot:basic>
        <!-- <el-form-item label="组织">
          <el-select
            v-model="query.marketId"
            placeholder="请选择组织"
          >
            <el-option
              v-for="(item, index) in $key.spotPurchaseSaleInquiry.organization"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item> -->
        <el-form-item label="客户号">
          <el-input
            v-model="query.tradeUserAccount"
            placeholder="请输入客户号"
          />
        </el-form-item>
        <el-form-item
          label="日期"
          class="datePicker"
        >
          <el-date-picker
            v-model="query.date"
            is-range
            arrow-control
            type="daterange"
            range-separator="至"
            start-placeholder="起始日期"
            end-placeholder="截止日期"
            placeholder="选择时间范围"
          />
        </el-form-item>
      </template>
    </table-search>
    <!-- 导出 -->
    <inquery-result isTips @export="toDownload" />
    <!-- 表格 -->
    <el-table
      ref="zTable"
      :data="tableData"
    >
      <el-table-column
        fixed
        label="序号"
        align="center"
        width="70px"
      >
        <template slot-scope="scope">
          {{ scope.$index+1 }}
        </template>
      </el-table-column>
      <af-table-column
        fixed
        prop="userAccount"
        label="客户"
      />
      <af-table-column
        fixed
        prop="tradeUserAccount"
        label="客户号"
      />
      <af-table-column
        fixed
        prop="userName"
        label="客户名称"
      />
      <af-table-column
        prop="goodsCode"
        label="购销计划"
      />
      <af-table-column
        prop="tradingDate"
        label="变更日期"
      />
      <el-table-column
        prop="entrustTs"
        label="订/变"
      >
        <template
          v-if="scope.row.userAccount !== ''"
          slot-scope="scope"
        >
          {{ Number(scope.row.entrustTs) | keyFilter("spotPurchaseSaleInquiry", "entrustTs") }}
        </template>
      </el-table-column>
      <el-table-column
        prop="entrustBs"
        label="购/销"
      >
        <template slot-scope="scope">
          {{ scope.row.entrustBs | keyFilter("spotPurchaseSaleInquiry", "entrustBs") }}
        </template>
      </el-table-column>
      <af-table-column
        prop="businessAmount"
        label="变更数量"
      />
      <af-table-column
        prop="businessPrice"
        label="变更价格"
      />
      <af-table-column
        prop="signHoldDate"
        label="订立日期"
      />
      <af-table-column
        prop="signHoldPrice"
        label="订立价格"
      />
      <af-table-column
        prop="closeProfit"
        label="预计当日补偿金"
      />
      <el-table-column
        prop="entrustType"
        label="订货类型"
      >
        <template slot-scope="scope">
          {{ scope.row.entrustType | keyFilter("spotPurchaseSaleInquiry", "entrustType") }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      layout="total, prev, pager, next"
      :current-page.sync="currentNo"
      :total="total"
      background
      @current-change="changePage"
    />
  </div>
</template>

<script>
import api from '@/api'

function Query () {
  this.marketId = '000' // 组织编号
  this.date = [] // 日期
}
export default {
  name: 'HistoricalBreakevenDetailsInquiry',
  data () {
    return {
      query: new Query(),
      currentNo: 1,
      total: 1,
      pageSize: 10,
      tableData: [], // 表格数据
      marketId: '',
      activeName: 'breakevenDetailsInquiry', // tab生效

      param: {},
    }
  },
  mounted () {
    this.fetchList(1)
  },
  methods: {
    // 分页查询
    async fetchList (currentNo, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentNo = currentNo || this.currentNo || 1
      let param = {
        ...this.query,
        currentNo: this.currentNo,
        pageSize: this.pageSize,
      }
      this.query.date = this.query.date ? this.query.date : []
      param.startDate = this.query.date.length ? this.$dayjs(this.query.date[0]).format('YYYYMMDD') : ''
      param.endDate = this.query.date.length ? this.$dayjs(this.query.date[1]).format('YYYYMMDD') : ''
      this.param = param
      let res = await api.spotPurchaseSaleInquiry.HistoricalHreakevenDetailsInquiry(param)
      this.total = res.data.totalElements
      this.tableData = res.data.rows
      this.marketId = this.query.marketId
    },
    // 重置搜索
    handleReset () {
      this.query = new Query()
      this.fetchList(1)
    },
    open (row) {
      this.row = row
      this.isShow = true
    },
    // 关闭弹窗
    shutDown () {
      this.isShow = false
    },
    // 导出
    toDownload () {
      let param = {
        ...this.param,
        tableUser: this.$store.state.user.name,
        tableName: '历史盈亏明细',
        excelParentPath: 'ucprofit',
        excelPath: 'queryHisProfitReport',
        marketId: this.marketId,
        currentNo: 1,
        pageSize: 2000,
        exportKeyMap: [{
          fieldLabel: '客户',
          excelColumn: 'userAccount'
        },
        {
          fieldLabel: '客户号',
          excelColumn: 'tradeUserAccount'
        },
        {
          fieldLabel: '客户名称',
          excelColumn: 'userName'
        },
        {
          fieldLabel: '购销计划',
          excelColumn: 'goodsCode'
        },
        {
          fieldLabel: '变更日期',
          excelColumn: 'tradingDate'
        },
        {
          fieldLabel: '订/变',
          excelColumn: 'entrustTs'
        },
        {
          fieldLabel: '购/销',
          excelColumn: 'entrustBs'
        },
        {
          fieldLabel: '变更数量',
          excelColumn: 'businessAmount'
        },
        {
          fieldLabel: '变更价格',
          excelColumn: 'businessPrice'
        },
        {
          fieldLabel: '订立日期',
          excelColumn: 'signHoldDate'
        },
        {
          fieldLabel: '订立价格',
          excelColumn: 'signHoldPrice'
        },
        {
          fieldLabel: '预计当日补偿金',
          excelColumn: 'closeProfit'
        },
        {
          fieldLabel: '订货类型',
          excelColumn: 'entrustType'
        },
        ]
      }
      this.$utils.getExcelFile(this, api.exportExcelData, param)
    },
    // 换页
    changePage (page) {
      this.fetchList(page)
    },
  }
}

</script>
